<template>
    <div>{{detailtext}}</div>
</template>
<script>
export default {
    props:['detailtext']
}
</script>